import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, Field, FieldArray, formValueSelector } from 'redux-form';
import { Form, Alert, Button, Row, Col } from 'antd';
import AntIcon from '../../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import moment from 'moment';

import {
  renderInput,
  renderTextarea,
  renderMultiSelect
} from '../../shared/utils/form_components';
import CommentFields from './CommentFields';

class PostForm extends Component {
  onSubmit(data, _d, { onSubmit }) {
    const date = moment.utc(data.createdAt).toISOString();

    return onSubmit({ ...data, date });
  }

  render() {
    const {
      handleSubmit, deleteError, error, submitting,
      deleteButton, deleteComment, modelTags
    } = this.props;
    const err = deleteError || error;

    return (
      <Row>
        <Col lg={{ span: 14, offset: 3 }} md={{ span: 18, offset: 2 }} xs={{ span: 24, offset: 0 }}>
          <Form layout="horizontal" onSubmit={handleSubmit(this.onSubmit)}>

            <Form.Item>
              <Row gutter={[8, 8]} type="flex" justify="end" className="page-form-actions">
                <Col>
                  <Button>
                    <Link to="/posts">Cancel</Link>
                  </Button>
                </Col>
                <Col>{deleteButton}</Col>
                <Col>
                  <Button
                    disabled={submitting} loading={submitting}
                    type="primary" htmlType="submit"
                  >
                    <AntIcon type="save" />Save
                  </Button>
                </Col>
              </Row>
            </Form.Item>

            {err && <Form.Item><Alert message={err} type="error" /></Form.Item>}

            <Field
              name="image"
              placeholder="Image"
              label="Post image"
              required
              component={renderInput}
            />

            <Field
              name="content"
              label="Content"
              autoSize={{ minRows: 4 }}
              required
              component={renderTextarea}
            />


            <Field
              name="tags.items"
              placeholder="Tag"
              label="Tags list"
              options={{items: modelTags}}
              component={renderMultiSelect}
            />

            <FieldArray
              name='comments'
              label="Comments"
              component={CommentFields}
              deleteComment={deleteComment}
            />

          </Form>
        </Col>
      </Row>
    )
  }
}

const selector = formValueSelector('PostForm');

export default compose(
  connect(
    (state) => ({
      hasStringPrice: selector(state, 'hasStringPrice'),
    }),
  ),
  reduxForm({
    form: 'PostForm'
  })
)(PostForm);
